// Select the element
var hamburger = document.querySelector('.hamburger--squeeze');

// Check if the element exists to avoid errors
if (hamburger) {
    // Add click event listener
    hamburger.addEventListener('click', function() {
        this.classList.toggle('is-active');
    });

    // Add hover event listener
    hamburger.addEventListener('mouseover', function() {
        this.classList.add('is-active');
    });

    // Optionally, remove the class when the mouse leaves the element
    hamburger.addEventListener('mouseout', function() {
        this.classList.remove('is-active');
    });
}

var expandLink = document.querySelectorAll('footer .expand-icon');

Array.from(expandLink).forEach(link => {
    link.addEventListener('click', function(event) {
      link.classList.toggle('expanded');
    });
});


var descriptionContent = $('#panel-01-product-description').html();
if ($('#panel-01-product-description').length) {

    if ($('.hide-on-desktop #panel-01-product-description .description').height() > 250){
      $('.hide-on-desktop #panel-01-product-description .description').addClass('sm-height');
      $('.hide-on-desktop #panel-01-product-description .read_more_pdp').removeClass('hide-on-mobile');
      var readmoretimespdp = 0;
      $('.read_more_pdp').on('click',function(){
      	readmoretimespdp ++;
        var rest = readmoretimespdp % 2;
        if (rest == 1) {
          $('.hide-on-desktop #panel-01-product-description .description').removeClass('sm-height');
          $('.read_more_pdp').html('Show less  <span class="chevron_up"></span>');
        } else {
          $('.hide-on-desktop #panel-01-product-description .description').addClass('sm-height');
          $('.read_more_pdp').html('Read more  <span class="chevron_down"></span>');
        }
      }); 
    }
}

 var readmoretimes = 0;
  $('.read_more').on('click',function(){
  	readmoretimes ++;
    var rest = readmoretimes % 2;
    if (rest == 1) {
      $('.long_description').show();
      $('.small_description').hide();
      $('.read_more').text('Show less');
    } else {
      $('.long_description').hide();
      $('.small_description').show();
      $('.read_more').text('Read more');
    }
  });
  var readmoretimesdsk = 0;
  $('.read_more_desktop').on('click',function(){
  	readmoretimesdsk ++;
    var rest = readmoretimesdsk % 2;
    if (rest == 1) {
      $('.long_description_desktop').show();
      $('.small_description_desktop').hide();
    } else {
      $('.long_description_desktop').hide();
      $('.small_description_desktop').show();
    }
  });
